import { render, staticRenderFns } from "./BaseLayerOpacity.vue?vue&type=template&id=a6b98a32&scoped=true&"
import script from "./BaseLayerOpacity.vue?vue&type=script&lang=js&"
export * from "./BaseLayerOpacity.vue?vue&type=script&lang=js&"
import style0 from "./BaseLayerOpacity.vue?vue&type=style&index=0&id=a6b98a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b98a32",
  null
  
)

export default component.exports